import { Box, FlexBox, Grid, Text } from '@trmediaab/zebra';
import { Fragment } from 'react';

export function GridTable({
  labels,
  data,
  gridTemplateColumns,
  alignColumnTitlesRight = false,
  showDivider = false,
  ...props
}) {
  if (!data.every(row => row.cells.length === labels.length)) {
    throw new Error(
      'Each row must have the same number of cells as the number of labels',
    );
  }

  return (
    <Grid gridTemplateColumns={gridTemplateColumns} {...props}>
      <Box
        display="contents"
        sx={{
          '> *': {
            bg: 'background.secondary',
            py: 2,
            mb: 2,
            pr: 3,
          },
        }}
      >
        {labels.map((label, idx) => (
          <Text
            key={idx}
            fontSize="10px"
            color="brands.travrondenSpel"
            fontWeight="semiBold"
            textAlign={alignColumnTitlesRight ? 'right' : undefined}
          >
            {label}
          </Text>
        ))}
      </Box>
      {data.map((row, idx) => (
        <Fragment key={idx}>
          <Box
            display="contents"
            sx={{
              '> *': {
                pt: 1,
                pb: row.extraRow != null ? 0 : 1,
                pr: 3,
              },

              "[data-extrarow='true']": {
                pt: 0,
                pb: 1,
              },
            }}
          >
            {row.cells.map((cell, cellIdx) => (
              <FlexBox key={cellIdx} alignItems="center">
                {cell}
              </FlexBox>
            ))}
            {row.extraRow != null && (
              <Box
                data-extrarow
                gridColumn="1/-1"
                {...row.extraRow.wrapperProps}
              >
                {row.extraRow.content}
              </Box>
            )}
          </Box>
          {showDivider && idx !== data.length - 1 && (
            <Box gridColumn="1/-1" height="1px" bg="greys.1" my="1" />
          )}
        </Fragment>
      ))}
    </Grid>
  );
}
